angular.module('bribac.translations', [
  'bribac.values',
  'pascalprecht.translate',
  'tmh.dynamicLocale',
  'bribac.translations.en',
  'bribac.translations.sv',
  'bribac.translations.kr'
])

  .constant('FALLBACK_LOCALE', 'en')

  .provider('availableLocales', function(
    VARIANT,
    EN_TRANSLATIONS,
    SV_TRANSLATIONS,
    KR_TRANSLATIONS
  ) {
    var locales = {
      'en': EN_TRANSLATIONS,
      'sv': SV_TRANSLATIONS
    }

    if (VARIANT === 'korea') {
      locales.ko = KR_TRANSLATIONS
    }

    this.set = function(_locales) {
      return (locales = _locales)
    }

    this.$get = function() {
      return locales
    }
  })

  .config(function(
    $translateProvider,
    $windowProvider,
    tmhDynamicLocaleProvider,
    availableLocalesProvider,
    LOCALE_LOCALSTORAGE_KEY,
    FALLBACK_LOCALE
  ) {
    var $window = $windowProvider.$get()
    var availableLocales = availableLocalesProvider.$get()

    availableLocalesProvider.set(availableLocales)

    // Register translations.
    Object.keys(availableLocales).forEach(function(locale) {
      $translateProvider.translations(locale, availableLocales[locale]);
    })
    tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.min.js')

    // Most recently set using `setLocale()`.
    var mostRecentLocale = $window.localStorage.getItem(LOCALE_LOCALSTORAGE_KEY)

    // Detect browser or system locale.
    $translateProvider.uniformLanguageTag('bcp47').determinePreferredLanguage()
    var detectedLocale = $translateProvider.preferredLanguage().split('-')[0]

    // Find default locale based on availability.
    var locale = FALLBACK_LOCALE
    if (availableLocales[mostRecentLocale]) locale = mostRecentLocale
    else if (availableLocales[detectedLocale]) locale = detectedLocale

    $translateProvider.preferredLanguage(locale)
    $translateProvider.fallbackLanguage(FALLBACK_LOCALE)
    tmhDynamicLocaleProvider.defaultLocale(locale)
    $window.document.documentElement.lang = locale
  })

  .run(function(
    $window,
    setLocale,
    getCurrentLocale
  ) {
    // Makes it easy to change locale from the browser console while developing.
    $window.BRIBAC = window.BRIBAC || {}
    $window.BRIBAC.setLocale = setLocale
    $window.BRIBAC.getCurrentLocale = getCurrentLocale
  })

  .factory('setLocale', function(
    $q,
    $translate,
    $window,
    LOCALE_LOCALSTORAGE_KEY,
    tmhDynamicLocale
  ) {
    return function setLocale(locale) {
      $window.document.documentElement.lang = locale
      $window.localStorage.setItem(LOCALE_LOCALSTORAGE_KEY, locale)
      return $q.all([
        $translate.use(locale),
        tmhDynamicLocale.set(locale)
      ])
    }
  })

  .factory('getCurrentLocale', function(
    $translate
  ) {
    return function getCurrentLocale() {
      return $translate.use()
    }
  })
